export default {"src":"/_next/static/media/store_offer_bonus_tag_gold.15502991.svg","height":50,"width":112,"blurWidth":0,"blurHeight":0};